import Circle from "../../../../../src/entities/Circle";
import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import SupplAngleManager from "../AngleManager/SupplAngleManager";
import LineManager from "../LineManager";
import { Coord } from "../../../../../src/types/Interface";
import { runIntroAnimation } from "./IntroAnimationSequence";
import PointTagManager from "../PointTagManager";
import CalculationLineManager from "../CalculationLineManager";
import SliderManager from "../SliderManager/SliderManager";
import { EventBus, EnumEventBus } from "../EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";


export default class IntroAnimationManager {
  private RootEventBus = RootEventBus;
  private EventBus = EventBus;

  constructor(// IntroAnimation function ,runIntroAnimation, use these managers.
    private PointManager: PointManager,
    private PointTagManager: PointTagManager,
    private AngleManager: AngleManager,
    private SupplAngleManager: SupplAngleManager,
    private LineManager: LineManager,
    private SliderManager: SliderManager,
    private CalcLineManager: CalculationLineManager,
    private circle: Circle,
    private cCoord: Coord,
  ) {
    this.drawAngles(this.PointManager.getRedPointsCoord(), false);
  }
  drawAngles = (rPointsCoord: Coord[], isbtw: boolean) => this.AngleManager.draw(rPointsCoord, isbtw);

  runAnimations() {
    this.EventBus.emit(EnumEventBus.setElementsForAnim, false);
    runIntroAnimation(this, () => {
      this.RootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      this.RootEventBus.emit(EnumRootEventBus.completedIntroAnim);
    });
  }
}
